<template>
    <div class="sales-card-prems" v-if="premsData.length">
        <div class="sales-card-section-title"><h2><span>{{ salesCardArr.project_name.name  }}</span>{{ salesCardArr.project_page_in.prems_section_title  }}</h2></div>
        <div class="prems-navigation">
            <ul>
                <li v-for="item in premsData" :class="{'active' : premsMenuActive == item.name}" @click.prevent="setPremsData(item)">{{ item.name }}</li>
            </ul>
        </div>
        <div class="prems-content-container">
            <div class="column-container">
                <div class="col-left">
                    <h3>{{ premsArr.title }}</h3>
                    <div class="col-desc" v-html="premsArr.desc"></div>
                    <button class="link-consult" @click="openContactsFormModal('call-page-get', cardID, 'Блок главное')">
                        <span>{{salesCardArr.project_page_in.setup_consult_btn}}</span>
                        <svgIcon name="right-arrow" class="icon-right-arrow"/>
                    </button>
                </div>
                <div class="col-right">
                    <div class="prems-carousel" v-if="premsCarouselInit">
                        <swiper :options="swiperOption" ref="premsCardCarousel" v-if="!isMobileChecker">
                            <swiper-slide v-for="(slide, index) in premsArr.images" :key="index">
                                <div class="promo-pic" :style="'background-image: url(' + slide + ')'"></div>
                            </swiper-slide>
                        </swiper>
                        <swiper :options="swiperOption" ref="premsCardCarousel" v-if="isMobileChecker">
                            <swiper-slide v-for="(slide, index) in premsArr.images_mobile" :key="index">
                                <div class="promo-pic" :style="'background-image: url(' + slide + ')'"></div>
                            </swiper-slide>
                        </swiper>
                        <div class="swiper-controls sales-card-prems-controls" v-if="premsArr.images.length > 1">
                            <div class="sales-card-prems-btn-prev slider-btn btn-wow-effect-hover">
                                <svgIcon name="arrow-left" class="icon-left-arrow"/>
                            </div>
                            <div class="sales-card-prems-btn-next slider-btn btn-wow-effect-hover">
                                <svgIcon name="arrow-right" class="icon-right-arrow"/>
                            </div>
                        </div>
                        <div class="swiper-pagination sales-card-prems-pagination" v-if="premsArr.images.length > 1"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue'
    export default {
        name: 'sales-card-prems',
        props: ['salesCardArr'],
        components: {
            svgIcon,
        },
        data () {
            return {
                cardID: this.$route.params.id,
                globalLang: window.GlobalLang, 
                premsData: [],
                premsMenuActive: 'arch',
                premsArr: null,
                premsCarouselInit: false,
                swiperOption: {
                    speed: 1000,
                    observer: true,
                    observeSlideChildren: true,
                    observeParents: true,
                    resizeObserver: true,
                    effect: 'slide',
                    // fadeEffect: {
                    //     crossFade: true
                    // },
                    slidesPerView: 1,
                    simulateTouch: true,
                    watchSlidesVisibility: true,
                    loop: true,
                    autoplay: {
                        delay: 3000,
                        disableOnInteraction: true,
                    },
                    navigation: {
                        nextEl: '.sales-card-prems-btn-next',
                        prevEl: '.sales-card-prems-btn-prev',
                    },
                    pagination: {
                        el: '.sales-card-prems-pagination',
                        type: 'bullets',
                        clickable: true,
                    },
                    breakpoints: {
                        // when window width is >= 900px
                        900: {
                            slidesPerView: 'auto',
                            spaceBetween: 20
                        },
                    }
                },
            }
        },
        computed: mapGetters({
            isMobileChecker: 'loadIsMobileChecker',
            // indexPage: 'loadIndexPage',
        }),
        methods: {
            openContactsFormModal(param, page, block) {
                this.$store.commit('formGlobalParam_set', param);
                this.$store.commit('formGlobalDataModal_set', {'page' : page, 'block' : block});
                this.$store.commit('formModalContainerOpen');
            },
            setPremsData(data) {
                this.premsCarouselInit = false;
                this.premsMenuActive = data.name
                this.premsArr = data;
                setTimeout(() => {
                    this.premsCarouselInit = true;
                }, 50);
            },  
            setPremsArr() {
                var defaultItems = [];
                var clearItems = [];
                defaultItems.push({
                    name: this.salesCardArr.project_page_in.arch_menu.name,
                    init: this.salesCardArr.project_page_in.arch_menu.init,
                    title: this.salesCardArr.project_page_in.arch_title,
                    desc: this.salesCardArr.project_page_in.arch_desc,
                    images: this.salesCardArr.project_page_in.arch_images,
                    images_mobile: this.salesCardArr.project_page_in.arch_images_mobile,
                });
                defaultItems.push({
                    name: this.salesCardArr.project_page_in.infra_menu.name,
                    init: this.salesCardArr.project_page_in.infra_menu.init,
                    title: this.salesCardArr.project_page_in.infra_title,
                    desc: this.salesCardArr.project_page_in.infra_desc,
                    images: this.salesCardArr.project_page_in.infra_images,
                    images_mobile: this.salesCardArr.project_page_in.infra_images_mobile,
                });
                defaultItems.push({
                    name: this.salesCardArr.project_page_in.flats_info_menu.name,
                    init: this.salesCardArr.project_page_in.flats_info_menu.init,
                    title: this.salesCardArr.project_page_in.flats_info_title,
                    desc: this.salesCardArr.project_page_in.flats_info_desc,
                    images: this.salesCardArr.project_page_in.flats_info_images,
                    images_mobile: this.salesCardArr.project_page_in.flats_info_images_mobile,
                });
                defaultItems.push({
                    name: this.salesCardArr.project_page_in.finish_menu.name,
                    init: this.salesCardArr.project_page_in.finish_menu.init,
                    title: this.salesCardArr.project_page_in.finish_title,
                    desc: this.salesCardArr.project_page_in.finish_desc,
                    images: this.salesCardArr.project_page_in.finish_images,
                    images_mobile: this.salesCardArr.project_page_in.finish_images_mobile,
                });
                defaultItems.push({
                    name: this.salesCardArr.project_page_in.lobbi_menu.name,
                    init: this.salesCardArr.project_page_in.lobbi_menu.init,
                    title: this.salesCardArr.project_page_in.lobbi_title,
                    desc: this.salesCardArr.project_page_in.lobbi_desc,
                    images: this.salesCardArr.project_page_in.lobbi_images,
                    images_mobile: this.salesCardArr.project_page_in.lobbi_images_mobile,
                });
                defaultItems.push({
                    name: this.salesCardArr.project_page_in.dvor_menu.name,
                    init: this.salesCardArr.project_page_in.dvor_menu.init,
                    title: this.salesCardArr.project_page_in.dvor_title,
                    desc: this.salesCardArr.project_page_in.dvor_desc,
                    images: this.salesCardArr.project_page_in.dvor_images,
                    images_mobile: this.salesCardArr.project_page_in.dvor_images_mobile,
                });
                defaultItems.push({
                    name: this.salesCardArr.project_page_in.service_menu.name,
                    init: this.salesCardArr.project_page_in.service_menu.init,
                    title: this.salesCardArr.project_page_in.service_title,
                    desc: this.salesCardArr.project_page_in.service_desc,
                    images: this.salesCardArr.project_page_in.service_images,
                    images_mobile: this.salesCardArr.project_page_in.service_images_mobile,
                });

                for (var i=0; i < defaultItems.length; i++) {
                    if (defaultItems[i].init) {
                        clearItems.push(defaultItems[i]);
                    }
                }

                this.premsData = clearItems;
                this.setPremsData(this.premsData[0]);
            },  
        },
        beforeCreate() {
        },
        created () {
        },
        mounted() {
            this.setPremsArr();
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales-card/sales-card-prems.scss';
    @import '@/styles/components/sales-card/respond/sales-card-prems-respond.scss';
    // @import '@/styles/components/sales-card/respond/sales-card-about-respond.scss';
</style>